export const ROLE_GROUPS = {
  superAdmin: 'SUPER_ADMIN',
  orgAdmin: 'ORG_ADMIN',
  orgManager: 'ORG_MANAGER',
  employee: 'EMPLOYEE',
} as const;

export type AppRole = keyof typeof ROLE_GROUPS;
export const ACTIVE_ROLE_STORAGE_KEY = 'engage.activeRole';

export function mapGroupsToRoles(groups: string[]): AppRole[] {
  const roles: AppRole[] = [];
  if (groups.includes(ROLE_GROUPS.superAdmin)) roles.push('superAdmin');
  if (groups.includes(ROLE_GROUPS.orgAdmin)) roles.push('orgAdmin');
  if (groups.includes(ROLE_GROUPS.orgManager)) roles.push('orgManager');
  if (groups.includes(ROLE_GROUPS.employee)) roles.push('employee');
  return roles;
}

export function mapGroupToRole(groups: string[]): AppRole | null {
  return mapGroupsToRoles(groups)[0] ?? null;
}

export function roleToApiRole(role: AppRole | null) {
  switch (role) {
    case 'superAdmin':
      return 'super_admin';
    case 'orgAdmin':
      return 'org_admin';
    case 'orgManager':
      return 'org_manager';
    case 'employee':
      return 'employee';
    default:
      return null;
  }
}

export function getStoredActiveRole(availableRoles: AppRole[]) {
  const stored = window.localStorage.getItem(ACTIVE_ROLE_STORAGE_KEY) as AppRole | null;
  return stored && availableRoles.includes(stored) ? stored : null;
}

export function storeActiveRole(role: AppRole | null) {
  if (role) {
    window.localStorage.setItem(ACTIVE_ROLE_STORAGE_KEY, role);
  } else {
    window.localStorage.removeItem(ACTIVE_ROLE_STORAGE_KEY);
  }
}

export function defaultPathForRole(role: AppRole | null) {
  switch (role) {
    case 'superAdmin':
      return '/super-admin';
    case 'orgAdmin':
      return '/org-admin';
    case 'orgManager':
      return '/org-manager';
    case 'employee':
      return '/employee';
    default:
      return '/unauthorized';
  }
}
